import { GET_STATION_OBSERVATIONS } from '../../../actions/WeatherStationObservations/SelectedStation/selectedStationObservationsAction';

import { LOCATION_CHANGED } from '../../../actions/locationActions';
import {
    IStationObservationsAPIItem,
} from "../../../types/APIResponses/WeatherStationObservations/WeatherStationObservationsResponses";

export interface SelectedStationObservationReducerState {
   data?: IStationObservationsAPIItem;
    isFetching: boolean;
    requestError?: boolean | Record<string, unknown> | unknown;
}

const initialState: SelectedStationObservationReducerState = {
    data: undefined,
    isFetching: false,
    requestError: undefined
};

export function selectedStationObservations(state = initialState, action) {
    switch (action.type) {
        case GET_STATION_OBSERVATIONS.pending:
        {
            return {
                ...state,
                requestError: undefined,
                isFetching: true
            };
        }

        case GET_STATION_OBSERVATIONS.fulfilled:
        {
            let data: IStationObservationsAPIItem;

            // Case: Fetched using Latitude / Longitude -- item is inside list as the first (and only) element
            const responseIsListFormat = action.payload?.c?.it ?? false;
            
            if (responseIsListFormat) {
                data = action.payload?.c?.it[0];
            }
            // Case: Fetched using ProviderId and StationId -- item is the response result
            else {
                data = action.payload;
            }
            
            return {
                ...state,
                data,
                isFetching: false,
                requestError: undefined
            };
        }

        case GET_STATION_OBSERVATIONS.rejected:
        {
            return {
                ...state,
                data: undefined,
                isFetching: false,
                requestError: action.payload
            };
        }
        default:
        {
            return state;
        }
    }
}

